import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteUser from "../user/DeleteUser";



const DeleteUserAlert = (props) => {
    const { onCompletion, id, onClose } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteUser onCompletion={onCompletion} id={id} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteUserAlert;